module.exports = __webpack_public_path__ + "assets/img/26@3x.49ff75e1.png";